import { Col, Row, Modal, Select, Form } from "antd";
import Title from "../UI/Title/Title";
import { useEffect, useState } from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { createExchangeRate } from "../../api/exchangerate";
import { UseMutateAsyncFunction, useMutation, useQuery } from "react-query";
import { getCurrencyMainDropdown } from "../../api/currency";
import AddEditModal from "../UI/ModalComponent/AddEditModal/addeditcomponent";
import { message } from "antd";
import { AxiosResponse } from "axios";
import { InputNumber } from "../UI/InputNumberComponent/inputnumber";

type prop = {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  CurencyRateMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      limit: number;
    },
    unknown
  >;
  page: number;
  setPaginatedCurencyRate: any;
};
interface option {
  value: string;
  id: number;
}

const AddExchange = ({
  isModalOpen,
  setIsModalOpen,
  CurencyRateMutation,
  page,
  setPaginatedCurencyRate,
}: prop) => {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState<any>(null);
  const [, setError] = useState();
  const [Rate, setRate] = useState(false);
  const { t } = useTranslation("common");

  const [currentTime, setCurrentTime] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      const time = new Date();
      const hours = time.getHours();
      const minutes = time.getMinutes();

      const formattedTime = `${hours}:${minutes}`;

      setCurrentTime(formattedTime);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const [, setInitialValues] = useState({ currId: undefined });
  const [formatedCurrency, setFormatedCurrency] = useState<option[]>();

  const { isLoading: loadingCurrency } = useQuery(
    "currencies",
    () => getCurrencyMainDropdown(false),
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedCurrency(
          res.data
            .map((currency: any) => {
              if (currency.isActive) {
                return { value: currency.id, label: currency.name };
              } else {
                return null;
              }
            })
            .filter((currency: any) => currency !== null)
        );

        if (res.data.length > 0) {
          setInitialValues({ currId: res.data[0].id });
        }
      },
    }
  );
  const { mutateAsync: createExchangeRateMutation, isLoading: isSaving } =
    useMutation("createExchangeRate", (newExchange: any) =>
      createExchangeRate(newExchange, newExchange.currId)
    );

  const currentDate = new Date();
  const year = String(currentDate.getFullYear());
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  const hours = String(currentDate.getHours()).padStart(2, "0");
  const minutes = String(currentDate.getMinutes()).padStart(2, "0");
  const seconds = String(currentDate.getSeconds()).padStart(2, "0");
  const formattedDate = `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;

  const handleFinish = async () => {
    const newExchange = form.getFieldsValue();
    newExchange.timestamp = formattedDate;
    for (const key in newExchange) {
      if (newExchange[key] === undefined) {
        newExchange[key] = true;
      }
    }
    newExchange.rate = Number(newExchange.rate);
    try {
      await createExchangeRateMutation(newExchange);
      setIsModalOpen(false);
      setOpen(false);
      const response = await CurencyRateMutation({ limit: page * 10 + 10 });
      setPaginatedCurencyRate(response.data?.data);
      message.success("Saved successfully!");
    } catch (error: any) {
      setError(error.response.data.errors[0].msg);
      message.error(error.response.data.errors[0].msg);
    }
    form.resetFields();
  };

  const handleRateChange = (value: any) => {
    setRate(value);
  };

  const handleCancel = () => {
    form.resetFields();
    setSelectedCurrency(null);
    setRate(false);
  };

  return (
    <>
      <Modal
        data-testid="modal"
        centered
        width={490}
        okText={`${t("add")}`}
        open={isModalOpen}
        cancelText={`${t("cancel")}`}
        onCancel={() => {
          setIsModalOpen(false);
          handleCancel();
        }}
        maskClosable={false}
        closable={false}
        okButtonProps={{
          style: {
            height: "40px",
            background: "#1677FF",
            color: "#fff",
            width: "100px",
          },
          disabled: !selectedCurrency || !Rate,
        }}
        cancelButtonProps={{
          style: {
            color: "#1677FF",
            border: "1px solid #1677FF",
            height: "40px",
            width: "100px",
          },
        }}
        onOk={() => {
          setOpen(true);
        }}>
        <Form
          data-testid="form"
          layout="vertical"
          form={form}
          id="exchangeForm"
          onFinish={handleFinish}>
          <Row>
            <Col offset={1} span={19} style={{ paddingBottom: "20px" }}>
              <Title title={`${t("add-exchange-rate")}`} />
            </Col>

            <Row style={{ color: "#C6B6B6" }}>
              <Col offset={1}>{moment().format("DD/MM/YYYY")}</Col>
              <Col offset={1}>{currentTime}</Col>
            </Row>

            <Col offset={1} span={14}>
              <Form.Item
                name="currId"
                label={`${t("currency")}`}
                rules={[
                  {
                    required: true,
                  },
                ]}>
                <Select
                  data-testid="currency"
                  placeholder={`${t("select-currency")}`}
                  loading={loadingCurrency}
                  options={formatedCurrency}
                  showSearch={true}
                  optionFilterProp="label"
                  onChange={(value: any) => setSelectedCurrency(value)}
                />
              </Form.Item>
              <Form.Item
                name="rate"
                label={`${t("exchange-rate")}`}
                rules={[
                  {
                    required: true,
                    message: "exchange rate is required",
                  },
                ]}>
                <InputNumber
                  maxLength={15}
                  onChange={handleRateChange}
                  data-testid="exchange"
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <AddEditModal
        form="exchangeForm"
        open={open}
        setOpen={setOpen}
        name={<span>{""}</span>}
        title={`${t("modal-exchangerate")}`}
        isSaving={isSaving}
      />
    </>
  );
};
export default AddExchange;
